import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveDataset } from '../../projectDetailsActivities.models';

export const RemoveDatasetActivity = ({ values }: IProjectActivity<IProjectActivityRemoveDataset>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_RemoveDataset')}
      <b>{values.name}</b>.
    </span>
  );
};
